<uni-form-select
    [control]="form.get('control')"
    [data]="optionLabels$ | async"
    [placeholder]="placeholder"
    [form]="form"
    [canClear]="canClear"
></uni-form-select>